{
  "salon-details-footer": {
    "text": {
      "contact-salon": "KONTAKT NA SALON",
      "closed": "Uzavřeno",
      "opening-time": "ČAS OTEVŘENÍ",
      "salon-location": "UMÍSTĚNÍ SALONU"
    }
  }
}
